import { useTheme } from 'styled-components';
import { ShieldCheckmark2Ic } from '@dsch/dd-icons';

import { Button } from 'components/Toolkit/Button/Button';
import * as Styled from 'components/SearchPage/TrustedDealerModal/TrustedDealerModal.styled';
import type { TrustedDealerModalProps } from 'components/SearchPage/TrustedDealerModal/TrustedDealerModal.typed';

const criteriaList = [
  {
    title: 'Vehicle Warranties',
    subtitle: 'Protection for you if something goes wrong',
  },
  {
    title: 'Outstanding Reviews',
    subtitle: 'Google rating of 3.5 stars or higher',
  },
  {
    title: 'Greenlight Verified Vehicles',
    subtitle: 'Ownership and vehicle history validated',
  },
  {
    title: 'Established Business',
    subtitle: 'Advertising on DoneDeal for at least 1 year',
  },
];

function TrustedDealerModal(props: TrustedDealerModalProps) {
  const { isOpen, askToClose } = props;

  const theme = useTheme();

  return (
    <Styled.SBaseModal
      isOpen={isOpen}
      askToClose={askToClose}
      showCloseIcon={false}
      testId="tdp-modal"
    >
      <Styled.Header
        title={<Styled.HeaderText>Certified Trusted Dealer</Styled.HeaderText>}
        icon={
          <ShieldCheckmark2Ic
            width={32}
            height={32}
            color={theme.colors.GREEN}
          />
        }
      />
      <Styled.OpeningText>
        This program highlights dealerships you can rely on. Dealers earn this
        certification by adhering to strict criteria, including:
      </Styled.OpeningText>
      <Styled.BodyText>
        {criteriaList.map((criteria, index) => {
          return (
            <Styled.SInfoListItem
              key={index}
              icon={<Styled.SIoCheckmark />}
              title={criteria.title}
              body={criteria.subtitle}
            />
          );
        })}
      </Styled.BodyText>
      <Styled.ClosingText>
        Plus, they must meet additional criteria so you know you can buy with
        confidence.
      </Styled.ClosingText>
      <Styled.ButtonContainer>
        <Button
          onClick={askToClose}
          data-tracking="tdp-close-btn"
          data-testid="tdp-close-btn"
        >
          Okay, got it!
        </Button>
      </Styled.ButtonContainer>
    </Styled.SBaseModal>
  );
}

export { TrustedDealerModal };
